import React, { useState, useEffect } from "react"
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap"

const DocumentViewerModal = ({ isOpen, toggle, documentUrl }) => {
  const [displayUrl, setDisplayUrl] = useState(null)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (isOpen && documentUrl) {
      const checkDocumentUrl = async () => {
        try {
          const response = await fetch(documentUrl, {
            method: "HEAD",
            mode: "no-cors",
          })

          const contentType = response.headers.get("Content-Type")

          const displayableTypes = [
            "text/html",
            "application/html",
            "text/plain",
            "application/xhtml+xml",
          ]

          if (displayableTypes.some(type => contentType?.includes(type))) {
            setDisplayUrl(documentUrl)
          } else {
            setDisplayUrl(null)
          }
        } catch (err) {
          console.error("Error checking document URL:", err)
          setError("Não foi possível verificar o documento")
          setDisplayUrl(null)
        }
      }

      checkDocumentUrl()
    }
  }, [isOpen, documentUrl])

  const handleDownload = () => {
    const link = document.createElement("a")
    link.href = documentUrl
    link.setAttribute("download", "")
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>Visualizar Documento</ModalHeader>
      <ModalBody>
        {error ? (
          <div className="text-center text-danger">{error}</div>
        ) : displayUrl ? (
          <div
            style={{
              height: "70vh",
              border: "1px solid #ccc",
            }}
          >
            <iframe
              src={displayUrl}
              title="Documento"
              style={{ width: "100%", height: "100%", border: "none" }}
              onError={() => {
                setError("Não foi possível carregar o documento")
                setDisplayUrl(null)
              }}
            />
          </div>
        ) : (
          <div className="text-center">
            <p className="text-muted mb-3">
              Este documento não pode ser visualizado diretamente.
            </p>
            <Button color="primary" onClick={handleDownload}>
              Baixar Documento
            </Button>
          </div>
        )}

        {displayUrl && (
          <div className="d-flex justify-content-end mt-3">
            <Button color="primary" onClick={handleDownload}>
              Baixar Documento
            </Button>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

export default DocumentViewerModal
